import { z } from 'zod';

export const DashboardRole = z.enum([
  'super_admin',
  'admin',
  'reseller',
  'customer_admin',
  'customer_operator',
  'billing_only',
  'read_only',
]);
export type DashboardRole = z.infer<typeof DashboardRole>;

export const Module = z.enum(['SPIDER', 'MARLIN', 'GECKO', 'RHINO', 'WAHOO']);
export type Module = z.infer<typeof Module>;

export const Environment = z.enum(['PROD', 'STAGE', 'DEMO', 'PPRO', 'OPEN', 'ANZR', 'DMO']);
export type Environment = z.infer<typeof Environment>;
